import React from 'react'
import { Redirect } from 'react-router-dom'
import { Footer, Header, Helmet } from 'shared/components'
import Branding from 'shared/branding'
import cognito from 'shared/cognito'
import ApplicationDataCapture from './ApplicationDataCapture'
import { APPLICATION_PATHS } from 'constants/paths'
import { ONLINE_STORE_BRAND_NAME, APPLICATION_TYPES } from 'constants/values'

const notAllowedForAnotherOption = [
  APPLICATION_TYPES.REFINANCE,
]

const AdverseActionPage = () => {
  const { name, key } = Branding.current
  const isAnotherOptionEligible = (applicationType, channel) =>
    !(
      key === ONLINE_STORE_BRAND_NAME.CCB ||
      notAllowedForAnotherOption.includes(applicationType) ||
      (channel !== 'RETAIL')
    )
  const isPasswordless = localStorage.getItem('isPasswordlessFlow') === 'true' && cognito.primaryRegion()

  return (
    <div className="mainBody">
      <Helmet brandName={name} pageName="Adverse Action" />
      <Header showLogInText={isPasswordless} />
      <ApplicationDataCapture
        render={({ appType, channel }) => {
          if (!isAnotherOptionEligible(appType, channel)) {
            return (
              <Redirect to={APPLICATION_PATHS.ADVERSE_ACTION_THANK_YOU} />
            )
          }
          return (<Redirect
            to={APPLICATION_PATHS.ADVERSE_ACTION_THANK_YOU}
          />)
        }}
      />
      <Footer />
    </div>
  )
}

export default AdverseActionPage
